import React from 'react';
import ProjectFiles from '../files';

export default function ProjectFilesTab({ project = {} }) {
    return (
        <div className="h-[calc(100vh-230px)] min-h-[650px] w-full">
            <ProjectFiles scopedProject={project} />
        </div>
    );
}
